export default __webpack_public_path__ + "static/Karla-Regular-cc1cbc0469951cea7a5bb2ccdea0cd4a.woff2";